<template>
  <app-content>
    <form action="#">
      <div class="inner">
        <p class="buttons">
          <app-button-delete @click="deleteItem" v-if="!newItem"/>
        </p>
        <app-content-title v-if="!newItem && !pending"
                           :title="item.name"/>
        <app-content-title v-if="newItem" :title="translations.newBackoffice"/>
      </div>
      <div :title="translations.information">
        <app-settings @submit="onFormSubmit" :disabled="pending">
          <app-settings-content>
            <app-settings-desc :title="translations.basicInfo">
              <p v-if="!newItem">
                <translate>Založeno</translate>
                :<br/>
                <span v-html="formatDateAdvanced(item._created)"/>
              </p>

              <p v-if="!newItem">
                <translate>Upraveno</translate>
                :<br/>
                <span v-html="formatDateAdvanced(item._updated)"/>
              </p>
            </app-settings-desc>

            <app-settings-options>
              <app-settings-col class="field_left">
                <app-input
                    :label="translations.name"
                    required
                    :error="errors.items.find(el => el.field === 'name')"
                    v-model="formItem.name"
                    name="name"

                />
              </app-settings-col>
              <app-settings-col class="field_right">
                <app-input
                    :label="translations.apiUrl"
                    :error="errors.items.find(el => el.field === 'apiUrl')"
                    v-model="formItem.apiUrl"
                    name="apiUrl"

                />
              </app-settings-col>
              <app-settings-col class="field_left">
                <app-input
                    :label="translations.localApiKey"
                    required
                    :error="errors.items.find(el => el.field === 'localApiKey')"
                    v-model="formItem.localApiKey"
                    name="localApiKey"

                />
              </app-settings-col>
              <app-settings-col class="field_right">
                <app-input
                    :label="translations.remoteApiKey"
                    :error="errors.items.find(el => el.field === 'remoteApiKey')"
                    v-model="formItem.remoteApiKey"
                    name="remoteApiKey"

                />
              </app-settings-col>
            </app-settings-options>
          </app-settings-content>

          <app-settings-buttons :navLinkTitle="translations.list" :nav-link-to="{ name: 'backoffices' }">
            <app-content-save-button :disabled="pending" @click="disallowBack"/>
          </app-settings-buttons>
        </app-settings>
      </div>
    </form>
  </app-content>
</template>

<script>
import getItemDetailMixin from 'mixins/getItemDetailMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { getCommonFormSubmit } from 'utils/form'

const itemDetailMixin = getItemDetailMixin({
  apiMethodsSuffix: 'Backoffice',
  parentRouteName: 'backoffices',
  storeModuleName: 'backoffices',
  storeItemName: 'backoffice'
})

export default {
  name: 'backoffice-item',
  mixins: [formatDateMixin, itemDetailMixin, appTitleMixin()],
  methods: {
    async onFormSubmit(e) {
      this.errors.clear()

      this.formErrors = await this.runValidation()
      if (this.formErrors.items.length > 0) {
        this.appShowErrors(this.formErrors.items.map(v => v.msg))
        return
      }

      const commonFormSubmit = getCommonFormSubmit('Backoffice')
      const response = await
          commonFormSubmit(this, e).catch(err => err.response)

      this.handleResponseIfError(response)

      if (!this.backAllowed && response.status === 201) {
        this.goToDetail(response.data.data._id)
      }
    },
    async runValidation() {
      await this.errors.clear()
      await this.$validator.validateAll()
      return this.errors
    }
  },
  computed: {
    translations() {
      return {
        newBackoffice: this.$gettext('Nový Backoffice'),
        name: this.$gettext('Název'),
        apiUrl: this.$gettext('API Url'),
        remoteApiKey: this.$gettext('Vzdálený API klíč'),
        localApiKey: this.$gettext('Místní API klíč'),
        list: this.$gettext('Seznam'),
        information: this.$gettext('Informace'),
        format: this.$gettext('Formát'),
        basicInfo: this.$gettext('Základní údaje'),
      }
    },
    currentTitle() {
      return [
        { name: this.$gettext('Backoffice'), link: { name: 'backoffices' } },
        this.item.name || this.translations.newBackoffice
      ]
    },
  }
}
</script>
